import routeMatcher from "./Routes.js";

const Router = {
    getRoute(routePath) {
        let route = routeMatcher(routePath);
        
        // If route page was an obj config, expand it
        if (route?.page.page) {
            route = {
                page: route.page.page,
                params: {
                    ...route.params,
                    ...route.page.params
                }
            }
        }

        return route;
    }
};

export default Router;